import styles from './ButtonBlue.module.scss';

const ButtonBlue = ({ onCilck, children }) => {
  return (
    <button onClick={onCilck} className={styles.button}>
      {children}
    </button>
  );
};

export default ButtonBlue;
